
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host(.slh-sidebar-navigation-wrapper) {
  display: block;
  overflow: hidden;
  background-color: var(--slh-color-neutral-shade-00, #FFFFFF);
  filter: drop-shadow(0px 6px 12px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.12)));
  -webkit-filter: drop-shadow(0px 6px 12px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.12)));
  border-radius: 16px;
  font-weight: var(--slh-base-bold-font-weight, 700);
  font-size: var(--slh-base-xs-font-size, 14px);
  font-family: var(--slh-default-font-family, "Open Sans");
  line-height: var(--slh-base-xxs-line-height, 24px);
}
:host(.slh-sidebar-navigation-wrapper) .items-holder {
  display: block;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 24px;
  padding-right: 24px;
}
:host(.slh-sidebar-navigation-wrapper) .items-holder .icon-wrapper {
  float: right;
  fill: var(--slh-color-neutral-shade-60, #62779F);
}
:host(.slh-sidebar-navigation-wrapper) .heading {
  display: none;
}
:host(.slh-sidebar-navigation-wrapper) ::slotted(.slh-sidebar-navigation-item-wrapper:not(:last-child)) {
  border-bottom: 1px solid var(--slh-color-neutral-shade-20, #EBEEF4);
}
:host(.slh-sidebar-navigation-wrapper) slot[name=heading]::slotted(*) {
  display: block;
  width: 100%;
  height: auto;
}
:host(.slh-sidebar-navigation-wrapper) .sidebar-holder.empty .items-holder {
  display: none;
}

:host(.slh-sidebar-navigation-wrapper.mobile) .sidebar-holder.empty {
  display: none;
}
:host(.slh-sidebar-navigation-wrapper.mobile) slot[name=heading]::slotted(*) {
  display: none !important;
}
:host(.slh-sidebar-navigation-wrapper.mobile) .items-holder {
  display: none;
}
:host(.slh-sidebar-navigation-wrapper.mobile) .heading {
  display: flex;
  justify-content: space-between;
  color: var(--slh-color-neutral, #39455D);
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 24px;
  padding-right: 24px;
  cursor: pointer;
  outline: none;
}
:host(.slh-sidebar-navigation-wrapper.mobile) .heading .icon-wrapper {
  float: right;
  fill: var(--slh-color-neutral-shade-60, #62779F);
}
:host(.slh-sidebar-navigation-wrapper.mobile) .heading:focus {
  text-decoration: underline;
}

:host(.slh-sidebar-navigation-wrapper.mobile.opened) .items-holder {
  display: block;
  padding-top: 0;
  padding-bottom: 0;
}
:host(.slh-sidebar-navigation-wrapper.mobile.opened) ::slotted(.slh-sidebar-navigation-item-wrapper:first-of-type) {
  border-top: 1px solid var(--slh-color-neutral-shade-20, #EBEEF4);
}
`;
